import type { CSSProperties, FC } from 'react'
import { lazy, Suspense } from 'react'
import { useColorModeContext } from '../Common/ColorModeProvider'
import LoadingPage from '../LoadingPage'
import { UIDialog } from '../ui/Modal'
import { dialog } from './DynamicModal'

const JSONView = lazy(() => import('@uiw/react-json-view'))

const InspectDialog: FC<{
  data?: unknown
}> = ({ data }) => {
  const { themeType } = useColorModeContext()

  return (
    <div className="p-8 min-h-[calc(100dvh-64px)]">
      <Suspense fallback={<LoadingPage />}>
        <JSONView
          value={data as object}
          style={
            themeType === 'dark'
              ? ({
                  '--w-rjv-font-family': 'monospace',
                  '--w-rjv-color': '#79c0ff',
                  '--w-rjv-key-string': '#79c0ff',
                  '--w-rjv-background-color': '#0d111700',
                  '--w-rjv-line-color': '#94949480',
                  '--w-rjv-arrow-color': '#ccc',
                  '--w-rjv-edit-color': 'var(--w-rjv-color)',
                  '--w-rjv-info-color': '#7b7b7b',
                  '--w-rjv-update-color': '#ebcb8b',
                  '--w-rjv-copied-color': '#79c0ff',
                  '--w-rjv-copied-success-color': '#28a745',
                  '--w-rjv-curlybraces-color': '#8b949e',
                  '--w-rjv-colon-color': '#c9d1d9',
                  '--w-rjv-brackets-color': '#8b949e',
                  '--w-rjv-quotes-color': 'var(--w-rjv-key-string)',
                  '--w-rjv-quotes-string-color':
                    'var(--w-rjv-type-string-color)',
                  '--w-rjv-type-string-color': '#a5d6ff',
                  '--w-rjv-type-int-color': '#79c0ff',
                  '--w-rjv-type-float-color': '#79c0ff',
                  '--w-rjv-type-bigint-color': '#79c0ff',
                  '--w-rjv-type-boolean-color': '#ffab70',
                  '--w-rjv-type-date-color': '#79c0ff',
                  '--w-rjv-type-url-color': '#4facff',
                  '--w-rjv-type-null-color': '#ff7b72',
                  '--w-rjv-type-nan-color': '#859900',
                  '--w-rjv-type-undefined-color': '#79c0ff',
                } as CSSProperties)
              : undefined
          }
          displayDataTypes={false}
          enableClipboard={false}
          collapsed={2}
          shortenTextAfterLength={40}
          highlightUpdates={false}
        />
      </Suspense>
    </div>
  )
}

/**
 * @deprecated use dialogInspectionForRAC if possible
 */
export const dialogInspection = (data?: unknown) => {
  dialog({
    children: <InspectDialog data={data} />,
    fullWidth: true,
    maxWidth: 'md',
    scroll: 'body',
  })
}

export const dialogInspectionForRAC = (data?: unknown) => {
  return UIDialog.create({
    dismissable: true,
    children: <InspectDialog data={data} />,
    className: 'w-[calc(100vw-64px)] max-w-screen-mlg',
  })
}
